var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallback(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_98865",
    "data-name": "Group 98865",
    transform: "translate(-1648.821 -64.821)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(1648.821 64.821)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-phone",
    "data-name": "Icon feather-phone",
    d: "M17.406,19.771c-.075,0-.151,0-.225-.01h-.015a17.408,17.408,0,0,1-7.551-2.685,17.193,17.193,0,0,1-5.25-5.25A17.4,17.4,0,0,1,1.679,4.238V4.225A2.5,2.5,0,0,1,4.165,1.5H6.682A2.5,2.5,0,0,1,9.157,3.65v.008A9.88,9.88,0,0,0,9.7,5.816a2.506,2.506,0,0,1-.563,2.635l0,0-.6.6a12.508,12.508,0,0,0,3.821,3.821l.6-.6,0,0a2.5,2.5,0,0,1,2.637-.562,9.875,9.875,0,0,0,2.157.537h.007a2.5,2.5,0,0,1,2.15,2.526v2.488a2.5,2.5,0,0,1-2.5,2.508ZM17.337,18.1l.069,0a.833.833,0,0,0,.833-.837s0,0,0,0v-2.5q0-.01,0-.021a.833.833,0,0,0-.714-.845,11.548,11.548,0,0,1-2.519-.628.833.833,0,0,0-.879.185l-1.056,1.056a.833.833,0,0,1-1,.135A14.171,14.171,0,0,1,6.758,9.336a.833.833,0,0,1,.135-1L7.949,7.279A.836.836,0,0,0,8.135,6.4,11.553,11.553,0,0,1,7.507,3.88a.837.837,0,0,0-.824-.714H4.166a.833.833,0,0,0-.829.9A15.731,15.731,0,0,0,5.765,10.92l0,.006a15.515,15.515,0,0,0,4.743,4.743l.006,0A15.733,15.733,0,0,0,17.337,18.1Z",
    transform: "translate(1654.325 71.911)",
    fill: "#c7131e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallback);
export default __webpack_public_path__ + "static/media/callback.dc058d4f6f59a19f11a0bf42f3ff7cc0.svg";
export { ForwardRef as ReactComponent };